module.exports = __webpack_public_path__ + "img/On_Location_Shoot_grayscale.cdc7f1c9.jpg";